module.exports = __webpack_public_path__ + "static/VS_icon06-01-c7f90c14e810d046a50bffa1df6ecf95.png";